import type { JSONContent } from "@tiptap/core";
import Fetcher from "../Fetcher.ts";
import type { VendorRelationship } from "./RFQ";
import type { RFQCommunication, RFQMailbox } from "./RFQMailbox";

export type RFQRejection = {
    id: number;
    rfqId: number;
    mailboxId: number;
    communicationId: number;
    createdAt: string;
    mailbox: RFQMailbox & {
        vendorRelationship: VendorRelationship;
    };
    communication: RFQCommunication;
};

export type CreateRejectionsParams = {
    rfqPublicId: string;
    content?: string;
    contentJson: JSONContent;
    mailboxIds: number[];
    senderId?: number | null;
};

export type CreateRejectionsResponse = {
    created: { id: number; mailboxId: number; communicationId: number }[];
    skipped: number[];
};

const f = Fetcher.default();

export default {
    getRFQRejections: (rfqPublicId: string) => {
        return f.get<{ data: RFQRejection[] }>(`/v2/rfqs/${rfqPublicId}/rejections`);
    },

    getMailboxRejection: (mailboxId: number) => {
        return f.get<RFQRejection>(`/mailboxes/${mailboxId}/rejections`);
    },

    createRejections: (params: CreateRejectionsParams) => {
        return f.post<CreateRejectionsResponse>(`/v2/rfqs/${params.rfqPublicId}/rejections`, {
            body: {
                content: params.content,
                contentJson: params.contentJson,
                mailboxIds: params.mailboxIds,
                senderId: params.senderId,
            },
        });
    },

    deleteRejection: (rejectionId: number) => {
        return f.delete<{ success: boolean }>(`/rejections/${rejectionId}`);
    },
};
